<template>
  <div class="x-date-picker">
    <flat-pickr
      v-model='flatPickrModel'
      :config='config'
      @on-change='changed'
      ref="datePickerWrap"
    >
    </flat-pickr>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { French } from 'flatpickr/dist/l10n/fr.js'

export default {
  name: 'x-date-range-picker',

  components: {
    flatPickr
  },

  props: {
    defaultRange: {
      type: Array,
      default: () => []
    },
    minDate: {
      type: String,
      default: null
    },
    maxDate: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      flatPickrModel: null,
      range: null,
      config: {
        mode: 'range',
        locale: French,
        inline: true,
        monthSelectorType: 'static',
        ignoredFocusElements: [document.body],
        defaultDate: this.defaultRange,
        minDate: this.minDate,
        maxDate: this.maxDate
      }
    }
  },

  methods: {
    changed (newDates) {
      this.range = newDates
      this.$emit('changed', this.range)
    }
  },

  watch: {
    defaultRange (nVal) {
      // Update flatpickr instance
      this.$refs.datePickerWrap.fp.setDate(nVal)
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  @import '~@/styles/datepicker.scss';
</style>
